<script setup>
const props = defineProps({
  cor: {
    type: String,
    required: true,
    default: 'AUMENTOU',
    validator(value) {
      return ['AUMENTOU', 'REDUZIU', 'ADICIONADO', 'EXCLUIDO'].includes(value);
    }
  },
})

const cores = {
  AUMENTOU: {
    principal: '#DFF2FF',
    segundaria: '#68B8EF',
  },
  REDUZIU: {
    principal: '#FFF4D7',
    segundaria: '#F3AD43',
  },
  ADICIONADO: {
    principal: '#CEF7E8',
    segundaria: '#0CB97B',
  },
  EXCLUIDO: {
    principal: '#FFD7DE',
    segundaria: '#FF385C',
  },
};
</script>

<template>
  <div
    class="pl-2 py-1 bra-5 font-weight-medium d-flex align-center justify-space-between"
    :style="{ backgroundColor: cores[cor].principal }"
  >
    <div class="quadrado-12 b-radius-100-percento" :style="{backgroundColor: cores[cor].segundaria}">&nbsp;</div>

    <div class="mx-auto px-2">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>

</style>
